import Item from './Item';
import MuiCheckbox from './MuiCheckbox';
import MuiCheckboxGroup from './MuiCheckboxGroup';
import MuiRadioGroup from './MuiRadioGroup';
import MuiSelect from './MuiSelect';
import MuiTextField from './MuiTextField';
import Password from './Password';

import adornment from './adornment';
import { requiredSelect } from './requiredItems';

const Form = {
  Item,
  MuiCheckbox,
  MuiCheckboxGroup,
  MuiRadioGroup,
  MuiSelect,
  MuiTextField,
  Password,

  adornment,
  requiredSelect,
};

export default Form;
